import React, { useContext, useState } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import { setIdCompany } from '../utils/constantes';
import Context from '../context/Context';
import '../componentes/molecules/Navbar/styles.css'

const countries = [
  { code: 'BR', name: 'Brazil', id:1 },
  { code: 'CO', name: 'Colombia', id:2 },
];

function CountryDropdown(props) {
  const { selectedCountry, setSelectedCountry } = useContext(Context);

  const handleCountrySelect = (eventCode) => {
    const country = countries.find(country => country.code === eventCode);
    setSelectedCountry(country);
    setIdCompany(country.id)
    if (props.onSelect) {
      props.onSelect(country);
    }
  };

  return (
    <div>
      <ReactFlagsSelect
        fullWidth={false}
        searchable={false}
        onSelect={handleCountrySelect}
        selected={selectedCountry ? selectedCountry.code : ''}
        countries={countries.map(country => country.code)}
        customLabels={countries.reduce(
          (obj, country) => ({ ...obj, [country.code]: country.name }),
          {}
        )}
        showSelectedLabel={false}
        placeholder="Selecione um País"
      />
    </div>
  );
}

export default CountryDropdown;